import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const ParcelTypesEnvelop: FC<SvgIconProps> = ({ viewBox = '0 0 254 170', ...props }) => (
  <SvgIcon viewBox={viewBox} fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
    <path d="M87.1164 8.5H166.883L177.259 31.2872H76.7403L87.1164 8.5Z" fill="#C39000" />
    <path d="M80.9557 15.6625H173.044V145.875H80.9557V15.6625Z" fill="white" />
    <path
      d="M172.072 16.312V144.897H81.9288V16.312H172.072ZM173.693 14.6844H80.3075V146.525H174.017L173.693 14.6844Z"
      fill="#E6E6E6"
    />
    <path d="M86.7926 25.1013H92.6291V26.729H86.7926V25.1013Z" fill="black" />
    <path d="M86.7926 31.6125H89.0624V33.2401H86.7926V31.6125Z" fill="black" />
    <path d="M95.2229 25.1013H108.842V26.729H95.2229V25.1013Z" fill="black" />
    <path d="M89.7104 31.6125H108.841V33.2401H89.7104V31.6125Z" fill="black" />
    <path d="M86.7926 28.3581H94.8989V29.9857H86.7926V28.3581Z" fill="black" />
    <path d="M95.2229 28.3581H100.411V29.9857H95.2229V28.3581Z" fill="black" />
    <path d="M101.06 28.3581H108.842V29.9857H101.06V28.3581Z" fill="black" />
    <path d="M76.7403 31.288H177.259V161.5H76.7403V31.288Z" fill="#FCCE09" />
    <path opacity="0.4" d="M87.1164 144.247H166.883L177.259 161.501H76.7403L87.1164 144.247Z" fill="#AA7B33" />
  </SvgIcon>
)
